import { baseApi } from "@/shared/api";
import type { ManagerAccessAction, ManagerBrief } from "../types";

export const managersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getManagers: builder.query<ManagerBrief[], void>({
      query: () => ({
        url: "/api/hr/managers/?include_inactive=1",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "Managers" as const, id: "LIST" }],
    }),
    changeManagerAccess: builder.mutation<ManagerBrief, { id: number; action: ManagerAccessAction }>({
      query: ({ id, action }) => ({
        url: `/api/hr/managers/${id}/${action}/`,
        method: "POST",
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Managers" as const, id: "LIST" }],
    }),
  }),
});

export const { useGetManagersQuery, useChangeManagerAccessMutation } = managersApi;
